import Vue from 'vue'
import Router from 'vue-router'

import process3D from '@/router/process3D'
import personal from '@/router/personal'
import factory from '@/router/factory'
import maintenance from '@/router/maintenance'

Vue.use(Router)

const routes = [
  {
    path: '*',
    redirect: '/'
  },
  {
    path: '/',
    meta: {
      allowAnonymous: true
    },
    component: resolve => require(['@/modules/personal'], resolve),
    children: [
      {
        path: 'index',
        name: 'index',
        alias: '/',
        meta: {
          allowAnonymous: true,
          headfixed: true
        },
        component: resolve => {
          require(['@/modules/personal/Index/index'], resolve)
        }
      },
      {
        path: 'scan',
        name: 'scan',
        meta: {
          allowAnonymous: true
        },
        component: resolve => {
          require(['@/modules/personal/Index/Scan'], resolve)
        }
      },
      {
        path: 'design',
        name: 'design',
        meta: {
          allowAnonymous: true
        },
        component: resolve => {
          require(['@/modules/personal/Index/Design'], resolve)
        }
      },
      {
        path: 'simulate',
        name: 'simulate',
        meta: {
          allowAnonymous: true
        },
        component: resolve => {
          require(['@/modules/personal/Index/Simulate'], resolve)
        }
      }
    ]
  },
  {
    path: '/materials/detail/:id',
    name: 'materials',
    meta: {
      allowAnonymous: true
    },
    props: true,
    component: resolve => {
      require(['components/material/MaterialsDetail'], resolve)
    }
  },
  {
    path: '/process',
    component: resolve => {
      require(['@/modules/personal/Print3D'], resolve)
    },
    children: process3D,
    redirect: '/process/require'
  },
  {
    path: '/usercenter',
    name: 'usercenter',
    meta: {
      redirect: {
        personal: 'orders',
        factory: 'mngmodelorder',
        maintenance: 'orders'
      }
    },
    component: resolve => require(['@/modules/UserCenter'], resolve),
    children: [
      ...personal,
      ...factory,
      ...maintenance
    ]
  },
  {
    path: '/about',
    name: 'about',
    component: resolve => {
      require(['@/modules/personal/About'], resolve)
    },
    children: [
      {
        path: 'clause',
        name: 'clause',
        meta: {
          allowAnonymous: true
        },
        component: resolve => {
          require(['@/components/intro/Clause'], resolve)
        }
      },
      {
        path: 'declare',
        name: 'declare',
        meta: {
          allowAnonymous: true
        },
        component: resolve => {
          require(['@/components/intro/Declare'], resolve)
        }
      }
    ],
    redirect: '/about/clause'
  },
  {
    path: '/inset',
    name: 'inset',
    component: resolve => require(['@/modules/personal/Inset'], resolve),
    children: [
      {
        path: 'annEngine',
        name: 'annEngine',
        desc: '关于安世数擎',
        meta: {
          allowAnonymous: true
        },
        component: resolve => require(['@/components/intro/AnnEngine'], resolve)
      }
    ],
    redirect: '/inset/annEngine'
  },
  {
    path: '/refresh',
    name: 'refresh',
    meta: {
      allowAnonymous: true,
      isMiddleware: true
    },
    component: {
      template: ''
    }
  }
]

const router = new Router({
  mode: 'history',
  base: '/print/',
  routes: routes
})

// 未选择自动登录时，防止刷新退出登录
let loginTime = window.localStorage.getItem('loginTime')
let allowRouting = true
if (!loginTime || ((new Date()).getTime() - loginTime) / 1000 > 3) {
  allowRouting = false
}

window.onbeforeunload = () => {
  window.localStorage.setItem('loginTime', new Date().getTime().toString())
}

router.beforeEach((to, from, next) => {
  if (!allowRouting) {
    allowRouting = true
    // 非自动登录时，重新打开页签退出登录
    // if (window.localStorage.getItem('autolog') !== 'true') {
    //   window.localStorage.setItem('Authorization', '')
    // }
  }

  // 验证是否登录
  router.app.$store.dispatch('userInfo').then(data => {
    // 告知to路由当前用户的角色身份
    to.params.roleName = data.roleName
    if (to.meta.redirect) {
      return next({name: to.meta.redirect[data.roleName]})
    }
    // 访客状态
    if (!router.app.$store.getters.isLogined) {
      if (!to.meta.allowAnonymous || (to.meta.isMiddleware && !from.meta.allowAnonymous)) {
        // 允许快速注册
        if (to.meta.canSimpleReg) {
          from.params.to = {name: to.name, params: to.params}
          return router.app.$store.commit('userEnter', {action: 'simpleReg'})
        } else {
          return Promise.reject()
        }
      }
      if (to.meta.isMiddleware && from.meta.allowAnonymous) {
        return next({name: from.name})
      }
    } else {
      // 临时中间件模块
      if (to.meta.isMiddleware) {
        return next({name: from.name})
      }
    }
    return next()
  }, () => {
    router.app.$store.dispatch('logout')
    next({path: '/', params: {login: window.localStorage.getItem('autolog') === 'true'}})
  })
})

router.beforeResolve((to, from, next) => {
  router.app.$store.state.contentLoading = true
  next()
})

router.afterEach((to, from) => {
  router.app.$store.state.contentLoading = false
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js